webpackJsonp([6],{

/***/ 147:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_gsap__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var _class = function (_Component) {
  _inherits(_class, _Component);

  function _class() {
    _classCallCheck(this, _class);

    return _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).apply(this, arguments));
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var ship = this.el.querySelector("#titanic-ship");
      var waveFg = this.el.querySelector("#titanic-wave-fg");
      var waveBg = this.el.querySelector("#titanic-wave-bg");

      this.animation = new TimelineMax();

      this.animation.to(ship, 3, {
        rotation: -10,
        transformOrigin: "center",
        repeat: -1,
        ease: Power1.easeInOut,
        yoyo: true
      }, 0);

      this.animation.to(waveFg, 3, {
        x: -323.766,
        ease: Power0.easeNone,
        repeat: -1
      }, 0);

      this.animation.from(waveBg, 3, {
        x: -323.766,
        ease: Power0.easeNone,
        repeat: -1
      }, 0);

      this.animation.paused(!this.props.isActive);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.animation.paused(!nextProps.isActive);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        "svg",
        { ref: function ref(el) {
            return _this2.el = el;
          }, viewBox: "0 0 672.2 672.2" },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "336.11", cy: "336.11", fill: "#73B2FF", r: "336.11" }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "defs",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "336.11", cy: "336.11", r: "336.11" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "clipPath",
          { id: "titanic-wave-bg-clip" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "336.11", cy: "336.11", r: "336.11" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { clipPath: "url(#titanic-wave-bg-clip)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "titanic-wave-bg",
            d: "M1097.44 350.86c-24.86-.5-44.87-3.1-59.1-5.6-15.48-2.75-30.63-6.5-31.56-6.74-18.04-4.48-22.66-6.73-34.8-9.22-8.33-1.62-20.7-3.5-36.43-3.37-15.72-.12-28.2 1.75-36.42 3.37-12.14 2.5-16.77 4.74-34.8 9.22-.93.25-16.08 4-31.57 6.73-14.22 2.5-34.23 5.1-59.1 5.6-24.85-.5-44.85-3.1-59.08-5.6-15.5-2.74-30.64-6.48-31.56-6.73-18.04-4.48-22.67-6.73-34.8-9.22-8.33-1.62-20.7-3.5-36.43-3.37-15.8-.12-28.3 1.75-36.5 3.37-12.2 2.5-16.8 4.74-34.8 9.22-1 .25-16.1 4-31.6 6.73-14.3 2.5-34.3 5.1-59.1 5.6-1.2 0-2.4-.04-3.6-.08-2.8-.08-5.5-.18-8.2-.3l-3.9-.22-2.1-.13c-.3 0-.6-.03-.9-.05l-2.1-.14-3.7-.27-2.6-.22-2.3-.2-1.2-.12-5-.5c-.6-.08-1.2-.14-1.8-.2L409 348l-.56-.1c-.9-.1-1.8-.2-2.67-.4h-.16l-2.4-.4c-.8-.1-1.6-.27-2.5-.4-3.6-.52-7-1.07-10.1-1.62-15.5-2.75-30.6-6.5-31.5-6.74-18-4.48-22.6-6.73-34.8-9.2-8.3-1.64-20.7-3.5-36.4-3.4-15.7-.1-28.2 1.76-36.4 3.4-12.1 2.5-16.7 4.7-34.8 9.2-.9.23-16 4-31.5 6.7-14.2 2.5-34.2 5.1-59.1 5.6-24.8-.5-44.8-3.1-59-5.6-15.5-2.73-30.6-6.47-31.6-6.72-18-4.48-22.7-6.7-34.8-9.2-7.4-1.47-18.1-3.1-31.6-3.36v359.7h1144V350.2c-5 .3-10.2.5-15.6.63z",
            fill: "#003B85"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { id: "titanic-ship" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            "g",
            null,
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M310.83 185.6l-17.63 12.96-6.75-9.18 17.64-12.95 6.7 9.18zm-65.8 34.2l-17.65 12.96 6.74 9.2L251.76 229l-6.74-9.2zm-59.1 43.4l-17.62 12.95 6.8 9.18 17.7-12.95-6.7-9.2zm-59.06 43.38l-17.64 12.95 6.75 9.18 17.63-12.9-6.7-9.2z",
              fill: "#10183F"
            }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
              d: "M326.4 206.8l-17.63 12.96-15.64-21.3 17.63-12.94 15.64 21.3zm-74.7 22.1l-17.65 12.95 15.64 21.3 17.6-12.96-15.7-21.3zm-59.08 43.38l-17.64 12.96 15.64 21.3 17.63-12.96-15.63-21.3zm-59.08 43.4L115.9 328.6l15.65 21.3 17.63-12.96-15.64-21.3z",
              fill: "#E09E41"
            })
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M470.14 214.83L105.4 482.67l-44.8-24.1 406.66-298.6c-5.83 21.16-2.26 40.57 2.88 54.86z",
            fill: "#10183F"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M477.46 242.55L131.38 496.67l-26-14 364.76-267.84c2.98 8.3 6.5 14.85 9 19.02 1.77 2.93 1.05 6.7-1.68 8.7z",
            fill: "#CC2E31"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M65.15 426.92L419.9 166.4l13.5 18.38L78.66 445.3z",
            fill: "#D9E2F1"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M81.5 386.63L376.53 170l27.4 8.17L81.1 415.2z",
            fill: "#F5F8FC"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M263.38 296.65l-4.8 3.53-1.06-1.44 4.8-3.53 1.06 1.5zm6.37-6.9l-4.8 3.53 1.06 1.43 4.8-3.5-1-1.4zm-14.87 10.93l-4.8 3.52 1.06 1.44 4.8-3.53-1.06-1.4zm-7.44 5.46l-4.8 3.52 1.06 1.44 4.8-3.52-1.06-1.44zM240 311.6l-4.8 3.52 1.07 1.44 4.8-3.52-1.06-1.44zm37.2-27.3l-4.8 3.5 1.05 1.45 4.8-3.52-1.06-1.44zm7.43-5.47l-4.8 3.52 1.06 1.44 4.7-3.6-1.1-1.5zm7.43-5.46l-4.8 3.52 1.06 1.4 4.8-3.5-1.06-1.5zm7.44-5.46l-4.8 3.6 1.06 1.5 4.8-3.5-1.06-1.4zm7.44-5.4l-4.8 3.5 1.05 1.5 4.8-3.5-1.1-1.4zm7.43-5.4l-4.8 3.5 1.06 1.5 4.8-3.5-1.06-1.4zm7.44-5.4l-4.8 3.6 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.6 1.1 1.4 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.6 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.5 1.1 1.5 4.8-3.5-1.1-1.4zm7.5-5.5l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.5 1.1 1.4 4.8-3.5-1.1-1.4zm7.5-5.5l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.5l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.6 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.6 1 1.4 4.8-3.5-1.1-1.4zm7.4-5.4l-4.8 3.6 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.5 1.1 1.4 4.8-3.5-1.1-1.4zm7.5-5.5l-4.8 3.5 1.1 1.4 4.8-3.5-1-1.4zM91.5 421l-4.8 3.55 1.1 1.47 4.8-3.5-1.1-1.45zm7.5-5.44l-4.8 3.5 1 1.4 4.8-3.5-1.1-1.45zm7.4-5.46l-4.8 3.5 1.03 1.47 4.8-3.5-1-1.43zm7.4-5.45l-4.8 3.5 1.1 1.45 4.8-3.55-1-1.45zm7.5-5.46l-4.8 3.5 1.1 1.4 4.8-3.6-1-1.4zm7.5-5.5l-4.8 3.5 1.1 1.4 4.8-3.6-1.1-1.4zm7.5-5.5l-4.8 3.5 1 1.4 4.8-3.6-1.1-1.5zm7.4-5.5l-4.8 3.5 1.1 1.4 4.8-3.6-1.1-1.5zm7.4-5.5l-4.8 3.5 1.1 1.4 4.8-3.6-1.1-1.4zm7.4-5.5l-4.8 3.5 1.1 1.4 4.8-3.6-1.1-1.5zm7.44-5.5l-4.8 3.5 1.03 1.5 4.8-3.5-1.08-1.4zm7.4-5.5l-4.8 3.5 1.06 1.4 4.8-3.5-1.07-1.5zm7.44-5.5l-4.8 3.5 1.1 1.4 4.8-3.5-1.05-1.5zm7.5-5.5l-4.8 3.5 1 1.4 4.8-3.6-1.1-1.5zm7.4-5.5L191 348l1 1.4 4.8-3.6-1.05-1.5zm7.4-5.5l-4.8 3.5 1.05 1.5 4.7-3.5-1-1.4zm7.4-5.5l-4.8 3.6 1.05 1.5 4.8-3.5-1.1-1.4zm7.4-5.4l-4.8 3.5 1.1 1.5 4.8-3.5-1.07-1.4zm7.5-5.4l-4.8 3.5 1 1.5 4.8-3.5-1.1-1.5zm7.4-5.4l-4.8 3.5 1.04 1.4 4.8-3.6-1-1.4zm7.42-5.5l-4.8 3.5 1.05 1.4 4.8-3.5-1.04-1.48z",
            fill: "#B0BED9"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M249.85 278.3l-4.8 3.52-1.06-1.44 4.8-3.53 1 1.44zm6.38-6.9l-4.8 3.52 1.05 1.43 4.8-3.52-1.05-1.44zm-14.88 10.92l-4.8 3.52 1.06 1.44 4.8-3.53-1-1.44zm-7.43 5.46l-4.8 3.52 1.05 1.44 4.8-3.52-1.05-1.44zm-7.44 5.46l-4.8 3.52 1.06 1.44 4.8-3.52-1.06-1.44zm37.18-27.3l-4.8 3.5 1.06 1.45 4.8-3.6-1.06-1.5zm7.44-5.47l-4.8 3.52 1.06 1.4 4.8-3.5-1.06-1.5zm7.43-5.46l-4.8 3.6 1.06 1.5 4.8-3.5-1.1-1.4zm7.44-5.4l-4.8 3.5 1.06 1.5 4.8-3.5-1.06-1.4zm7.44-5.4l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.6 1.1 1.4 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.6 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.5 1.1 1.4 4.8-3.5-1.1-1.4zm7.5-5.5l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.5zm7.4-5.4l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.4zm7.5-5.4l-4.8 3.5 1.1 1.4 4.8-3.5-1-1.4zm7.4-5.4l-4.8 3.6 1.1 1.4 4.8-3.5-1.1-1.4zm7.5-5.4l-4.8 3.6 1.1 1.5 4.8-3.6-1-1.4zm7.5-5.4l-4.8 3.6 1.1 1.5 4.8-3.5-1.1-1.4zm-275.2 202l-4.8 3.5 1.1 1.5 4.8-3.5-1.1-1.4zm7.5-5.4l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.5zm7.5-5.4l-4.8 3.5 1 1.48 4.8-3.5-1.1-1.42zm7.4-5.5l-4.8 3.6 1 1.47 4.8-3.5-1-1.5zm7.4-5.4l-4.8 3.57 1.1 1.43 4.8-3.5-1-1.4zm7.5-5.42L133 363l1.1 1.5 4.8-3.53-1.1-1.43zm7.4-5.5l-5 3.38 1.1 1.4 4.8-3.5-1.1-1.4zm7.5-5.5l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.5zm7.4-5.4l-4.8 3.5 1.1 1.5 4.8-3.5-1-1.45zm7.4-5.6l-4.8 3.5 1.1 1.5 4.8-3.5-1.1-1.5zm7.5-5.4l-4.8 3.53 1.1 1.4 4.8-3.5-1-1.4zm7.4-5.46l-4.8 3.5 1.1 1.4 4.8-3.5-1-1.5zm7.5-5.5l-4.8 3.5 1.1 1.4 4.8-3.5-1.1-1.5zm7.5-5.5l-4.8 3.5 1 1.4 4.8-3.56-1.1-1.4zm7.4-5.5l-4.8 3.5 1.07 1.4 4.8-3.5-1.1-1.43zm7.4-5.5l-4.8 3.5 1.1 1.47 4.8-3.53-1.1-1.4zm7.5-5.44l-4.8 3.5 1.1 1.42 4.8-3.5-1.05-1.5zm7.5-5.5l-4.8 3.5 1.1 1.5 4.8-3.5-1.06-1.46z",
            fill: "#BECADE"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { id: "titanic-iceberg", opacity: ".8" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M517.64 262.1l14.77-38.92s34.5 36.7 32.8 37.06c-1.7.36 3.1-5.82 3.1-5.82l20.4 35.97v22.4l28 22.1-34.1 40.9-7.5 47.2-10.7-15-3.6 69.3-64.3-80.7.4-35-17.7-51.2 14 2.9-5.2-5.1 7-23.2 22.7-23z",
            fill: "#FFF"
          }),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            d: "M525.04 279.63l9.26-43.15s28.58 44.64 27.27 44.9c-1.32.28 3.77-8.12 3.77-8.12l13.2 27.7v16.88l29.68 16.38-27.02 32.62-9.32 41.64-9.5-7.13-5.95 54.8-56.67-68.4-.22-39.03-12.34-24.3 17.48-2.7-4.46-12.36 1.42-21.2 23.4-8.53z",
            fill: "#8FC1FF"
          })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "defs",
          null,
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "336.11", cy: "336.11", r: "336.11" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "clipPath",
          { id: "titanic-wave-fg-clip" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", { cx: "336.11", cy: "336.11", r: "336.11" })
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          "g",
          { clipPath: "url(#titanic-wave-fg-clip)" },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
            id: "titanic-wave-fg",
            d: "M1149.23 685.67V325.93c-15.72-.13-28.2 1.75-36.42 3.37-12.1 2.5-16.7 4.73-34.8 9.22-.9.25-16 4-31.5 6.73-14.2 2.5-34.2 5.1-59.1 5.6-24.8-.5-44.8-3.1-59.1-5.6-15.5-2.74-30.6-6.48-31.5-6.73-18-4.5-22.6-6.73-34.8-9.22-8.3-1.62-20.7-3.5-36.4-3.37-15.7-.13-28.2 1.75-36.4 3.37-12.1 2.5-16.7 4.73-34.8 9.22-.9.25-16.1 4-31.6 6.73-14.2 2.5-34.2 5.1-59 5.6-24.9-.5-44.9-3.1-59.1-5.6-15.5-2.74-30.6-6.48-31.5-6.73-18-4.5-22.6-6.73-34.8-9.22-8.3-1.62-20.7-3.5-36.4-3.37-15.7-.13-28.2 1.75-36.4 3.37-12.1 2.5-16.7 4.73-34.8 9.22-.9.25-16 4-31.5 6.73-14.2 2.5-34.2 5.1-59.1 5.6-24.8-.5-44.8-3.1-59.1-5.6-15.5-2.74-30.6-6.48-31.5-6.73-18-4.5-22.7-6.73-34.8-9.22-8.3-1.62-20.7-3.5-36.4-3.37-15.7-.13-28.2 1.75-36.4 3.37-12.1 2.5-16.7 4.73-34.8 9.22-.9.25-16 4-31.5 6.73-14.2 2.5-34.2 5.1-59.1 5.6-19.4-.38-35.9-2.07-48.9-3.98v338.8h1182.1z",
            fill: "#0060D6",
            opacity: ".59"
          })
        )
      );
    }
  }]);

  return _class;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["default"] = (_class);

/***/ })

});


// WEBPACK FOOTER //
// 6.cb13787fc3cc8398f3e8.js